@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;

.main-container {
	display: flex;
	justify-content: space-between;
}

.info-header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.info-container {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: Constants.$val-spacing-s;
}

.info {
	display: flex;
	flex-direction: column;
	box-shadow: 0px 0px 3px;
	margin: Constants.$val-spacing-s;
}

.info-block {
	padding: Constants.$val-spacing-s;
	box-shadow: 0px 0px 1px;
}

.revision {
	background-color: Colors.$col-design-orange5;
}

.current {
	background-color: Colors.$col-design-red4;
}

.field {
	font-weight: bold;
	margin-bottom: Constants.$val-spacing-s;
}

.field-name {
	font-size: Constants.$val-fontSizeXSmall;
}

.notes-field-name {
	color: Colors.$col-greyFontLight;
}

.group-name {
	color: Colors.$col-greyFontLight;
	font-size: Constants.$val-fontSizeSmall;
	padding-left: Constants.$val-spacing-s;
}

.group-info {
	display: flex;
	flex-direction: row;
	font-weight: bold;
	font-size: Constants.$val-fontSizeSmall;
	margin-right: Constants.$val-spacing-s;
}

.check {
	color: Colors.$col-green;
	margin-right: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeRegular;
}

.clock {
	color: Colors.$col-orange;
	margin-right: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeRegular;
}

.notes-field {
	margin-bottom: Constants.$val-spacing-s;
}

.map-link {
	font-weight: normal;
	color: Colors.$col-blue;
	text-decoration: underline;
}

.label-container {
	margin: 0;
	padding: 0;
	display: inline;
}

.label {
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-xs;
	display: inline-block;
	background-color: Colors.$col-white;
	box-shadow: 0px 0px 1px;
	font-weight: bold;
	width: 60%;
	text-transform: uppercase;

	&.dynamicBackgroundColor {
		background-color: var(--dynamic-color);
		color: Colors.$col-white;
	}

	&.dynamicTextColor {
		color: var(--dynamic-color);
	}
}